module.exports = __webpack_public_path__ + "img/menu.9d07e7c.svg";